import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1efff09a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efff09a')) {
      api.createRecord('1efff09a', component.options)
    } else {
      api.reload('1efff09a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1efff09a", function () {
      api.rerender('1efff09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/Index.vue"
export default component.exports